import { useCallback, useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "sonner";
import { ArrowLeft, Waypoints } from "lucide-react";
import { apiError, customerClient } from "../lib/api";
import { MessageThread } from "../components/MessageThread";

export default function CustomerThread() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [sending, setSending] = useState(false);

  const load = useCallback(() => {
    customerClient()
      .get(`/public/conversations/${id}`)
      .then(({ data }) => setData(data))
      .catch(() => navigate("/customer/login"));
  }, [id, navigate]);

  useEffect(() => {
    load();
  }, [load]);

  const fulfill = async (requestId, reqFiles) => {
    try {
      const fd = new FormData();
      fd.append("body", "Uploaded the requested files.");
      fd.append("request_id", requestId);
      reqFiles.forEach((f) => fd.append("files", f));
      await customerClient().post(`/public/conversations/${id}/messages`, fd);
      toast.success("Files sent");
      load();
    } catch (e) {
      toast.error(apiError(e));
    }
  };

  const send = async (body, files) => {
    setSending(true);
    try {
      const fd = new FormData();
      fd.append("body", body);
      files.forEach((f) => fd.append("files", f));
      await customerClient().post(`/public/conversations/${id}/messages`, fd);
      load();
    } catch (e) {
      toast.error(apiError(e));
      return false;
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="h-screen bg-[#FAFAFA] flex flex-col" data-testid="customer-thread-page">
      <header className="bg-white border-b border-[#E5E5E5] shrink-0">
        <div className="max-w-3xl mx-auto px-6 h-16 flex items-center gap-4">
          <Link to="/customer/conversations" data-testid="thread-back-link">
            <ArrowLeft className="h-5 w-5 text-neutral-500" />
          </Link>
          <Waypoints className="h-5 w-5" />
          <div>
            <div className="font-heading font-bold leading-tight" data-testid="thread-business-name">
              {data?.conversation?.business_name || "…"}
            </div>
            <div className="text-xs text-neutral-400">{data?.conversation?.form_title}</div>
          </div>
        </div>
      </header>
      <main className="flex-1 max-w-3xl w-full mx-auto min-h-0">
        {data ? (
          <MessageThread
            messages={data.messages}
            selfSender="customer"
            onSend={send}
            sending={sending}
            testPrefix="customer-thread"
            onFulfillRequest={fulfill}
          />
        ) : (
          <p className="p-6 text-neutral-400">Loading…</p>
        )}
      </main>
    </div>
  );
}
